export default "__VITE_ASSET__2a0884f7__"